module.exports = __webpack_public_path__ + "img/main.a56d9ee3.png";